import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/browser";

import Root from "./Root.js";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://47fd9ced46b74a558b5148df53e02b1d@sentry.io/2085808",
  });
}

const render = () => {
  console.log({ hot: module.hot });
  ReactDOM.render(<Root />, document.getElementById("root"));
};

render();

console.log("env", process.env.NODE_ENV);

if (process.env.NODE_ENV === "development" && module.hot) {
  module.hot.accept("./Root", render);
}
